module.exports = __webpack_public_path__ + "static/img/video_icon3.3761d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/video_icon3.png
// module id = YoGF
// module chunks = 0